import React, { useEffect } from 'react';

import debounce from 'lodash/debounce';
import { Avatar } from '@material-ui/core';

import { ChatUser } from '@vyce/core/src/types';
import { ControlledAutocomplete } from '@vyce/core/src/components/controlled-inputs/ControlledAutocomplete';

import { AppChip } from '../AppChip';

interface Props {
  users: ChatUser[];
  onSearch: (substring: string) => void;
  label?: string;
  selectedItems?: ChatUser[];
}

export const ChatSearchUsersAutocomplete: React.FC<Props> = ({
  users,
  onSearch,
  label = 'Users',
  selectedItems,
}) => {
  const debouncedOnSearch = React.useRef(debounce(onSearch, 500));

  useEffect(() => {
    debouncedOnSearch.current = debounce(onSearch, 500);
  }, [onSearch]);

  const handleSearch = (value: string) => {
    debouncedOnSearch.current(value);
  };

  const renderCustomChip = (
    item: ChatUser,
    field: any,
    deleteItem: (field: any, item: ChatUser) => void
  ) => {
    return (
      <AppChip
        style={{ height: 40, marginBottom: 4, marginRight: 8 }}
        label={item.name}
        onDelete={() => deleteItem(field, item)}
        avatar={
          <Avatar style={{ marginLeft: 0, marginRight: 4, width: 32, height: 32 }} src={item.avatarUrl} />
        }
      />
    );
  };

  return (
    <ControlledAutocomplete
      selectedItems={selectedItems}
      name="users"
      items={users}
      multiple
      label={label}
      onChange={handleSearch}
      renderCustomChip={renderCustomChip}
    />
  );
};
